import {
  PostOrPatchServiceUserDto,
  ZitadelServiceUser,
} from "@src/types/user-management";

export const buildRequestObjectForServiceUser = (
  user: Partial<ZitadelServiceUser>,
): PostOrPatchServiceUserDto => {
  return {
    username: user.username,
    name: user.name,
    description: user.description,
    roles: user.roles,
    expiration_date: user.expiration_date,
  };
};
